import { ArrowRight } from "lucide-react";
import { RevealText, Reveal } from "./Reveal";
import { Brand } from "./brand";
import { scrollToSection } from "../../lib/scrollToSection";

const lines = [
  { id: "business-visibility", text: "Ayudamos a que tu negocio sea encontrado," },
  { id: "business-recommendation", text: "elegido y recomendado." },
];

const HeroActions = () => (
  <Reveal delay={0.5} className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
    <button data-testid="hero-cta" onClick={() => scrollToSection("contacto")}
      className="group flex items-center gap-2 rounded-full bg-[#00E5FF] px-8 py-4 text-base font-semibold text-[#0A0A0C] transition-transform hover:-translate-y-1 hover:shadow-[0_18px_50px_-12px_rgba(0,229,255,0.6)]">
      Solicita tu presupuesto
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
    </button>
    <button data-testid="hero-packs-button" onClick={() => scrollToSection("packs")}
      className="rounded-full border border-white/20 px-8 py-4 text-base font-medium text-white transition-colors hover:bg-white/10">
      Ver packs
    </button>
  </Reveal>
);

export const HeroContent = () => (
  <>
    <Reveal>
      <span data-testid="hero-tagline" className="inline-block rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.2em] text-[#00E5FF]">
        Diseño web para negocios
      </span>
    </Reveal>
    <Reveal delay={0.1} className="mt-10 flex justify-center">
      <img src="/webessence-logo.png" alt="Logo de WebEssence, una W estilizada" data-testid="hero-logo"
        className="h-24 w-24 object-contain drop-shadow-[0_8px_30px_rgba(0,229,255,0.25)] sm:h-32 sm:w-32" />
    </Reveal>
    <h1 data-testid="hero-title" className="mt-6 font-head text-5xl font-light leading-[0.95] tracking-tighter text-white min-[400px]:text-6xl sm:text-7xl lg:text-[8rem]">
      <Brand light="font-extralight" heavy="font-black" />
    </h1>
    <div data-testid="hero-description" className="mt-8 text-lg text-zinc-300 sm:text-xl">
      <RevealText lines={lines} lineClassName="font-head font-light" />
    </div>
    <HeroActions />
  </>
);